export { RemainingCharsCountDirective } from './remaining-chars-count.directive';
export { RemainingCharsCountModule } from './remaining-chars-count.module';
